import { PersonsDependentCommitmentsService_personDependentCommitmentsVersionServiceGetQuery } from '@festina/life-general-types/life/hooks/PersonsDependentCommitmentsService_personDependentCommitmentsVersionServiceGetQuery'

export const useFetchDependentCommitments =
  PersonsDependentCommitmentsService_personDependentCommitmentsVersionServiceGetQuery.useSuspenseQuery
